import React from "react";
import Data from './data';
import { HashLink } from 'react-router-hash-link';

const namespace = 'expreso-el-vasquito';

function Informacion() {
  return(
    <div className={`${namespace}__informacion`}>
      <div className="content-app">
        <h2 className={`${namespace}_title`}>Información</h2>
        <div className={`content-app ${namespace}__nosotros-left`}>
          {Data.map((e, index) =>
            <div className={`card-informacion`}>
              <img className={`${namespace}__image-svg`} src={`assets/svg/${index+1}.svg`} alt="img"/>
              <p className={`card-informacion-text`}>{e.text}</p>
            </div>
          )}
        </div>
        <div className={`${namespace}-content-buttons-sucursales`}>
          <a target="_blank" href={`https://ofimovil.net.ar/LOG360/web/VASQUITO/cotizar2`}className={`button_informacion`}>Cotizador</a>
          <HashLink className={`button_informacion`} to={`/#retiro`}>Retiro</HashLink>
        </div>
      </div>
    </div>
  )
}

export default Informacion;